import styled, { css } from 'styled-components'

export const Wrapper = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0 auto 30px;
  padding: 16px ${({ smallPaddings }) => (smallPaddings ? '20px' : '40px')} 14px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;
  ${({ theme, primary }) => primary && `color:  white;`}
  ${({ theme, orange }) => orange && `color:  ${theme.colors.orange};`}
  ${({ theme, ghost }) => ghost && `color:  ${theme.colors.purple};`}
  ${({ theme, ghostWhite }) => ghostWhite && `color:  white;`}
  cursor: pointer;
  ${({ theme, primary }) =>
    primary &&
    css`
      background-color: ${theme.colors.purple};
      border: 1px solid ${theme.colors.purple};
    `}
  ${({ theme, orange }) =>
    orange &&
    css`
      border: 1px solid ${theme.colors.orange};
    `}
  ${({ theme, ghost }) =>
    ghost &&
    css`
      border: 1px solid ${theme.colors.purple};
    `}
    ${({ theme, ghostWhite }) =>
    ghostWhite &&
    css`
      border: 1px solid white;
    `}

  &::before {
    content: '';
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ${({ theme, primary }) =>
      primary &&
      css`
        background-color: white;
      `}
    ${({ theme, orange }) =>
      orange &&
      css`
        background-color: ${theme.colors.orange};
        border: 1px solid ${theme.colors.orange};
      `}
  ${({ theme, ghost }) =>
      ghost &&
      css`
        background-color: ${theme.colors.purple};
        border: 1px solid ${theme.colors.purple};
      `}
      ${({ theme, ghostWhite }) =>
      ghostWhite &&
      css`
        background-color: white;
        border: 1px solid white;
      `}
      border-radius: 40px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    color: ${({ theme, orange }) =>
      orange ? theme.colors.white : theme.colors.purple};

    ${({ theme, primary }) =>
      primary &&
      css`
        color: ${theme.colors.purple};
      `}
    ${({ theme, orange }) =>
      orange &&
      css`
        color: white;
        border: 1px solid ${theme.colors.orange};
      `}
  ${({ theme, ghost }) =>
      ghost &&
      css`
        color: white;
        border: 1px solid ${theme.colors.purple};
      `}
      ${({ theme, ghostWhite }) =>
      ghostWhite &&
      css`
        color: ${theme.colors.purple};
      `}

    &::before {
      opacity: 1;
    }
  }

  ${({ theme }) => theme.media.s} {
    padding: 18px ${({ smallPaddings }) => (smallPaddings ? '22px' : '42px')}
      16px;
    font-size: 12px;
  }

  ${({ theme }) => theme.media.m} {
    display: inline-flex;
    margin: 0;
    padding: 18px ${({ smallPaddings }) => (smallPaddings ? '22px' : '42px')}
      16px;
    font-size: 14px;
  }

  ${({ theme }) => theme.media.l} {
    padding: 19px ${({ smallPaddings }) => (smallPaddings ? '22px' : '44px')}
      17px;
    font-size: 16px;
  }

  ${({ theme }) => theme.media.xl} {
    padding: 19px ${({ smallPaddings }) => (smallPaddings ? '22px' : '48px')}
      17px;
    font-size: 18px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding: 20px ${({ smallPaddings }) => (smallPaddings ? '24px' : '54px')}
      18px;
    font-size: 20px;
  }
`

export const Label = styled.p`
  position: relative;
  display: block;
  transition: color 0.3s ease;
  transition-delay: 0s;
  z-index: 2;

  > span {
    psoition: relative;

    &:nth-child(1) {
      display: inline-block;
    }

    &:nth-child(2) {
      display: none;
    }
  }

  ${({ theme }) => theme.media.l} {
    > span {
      &:nth-child(1) {
        display: none;
      }

      &:nth-child(2) {
        display: inline-block;
      }
    }
  }
`
